import React, { useCallback } from "react";
import { Container, Content, SecondContainer } from "../../shared.styled";
import { Typography, ChatInput } from "@ann/web-components";
import { useHomeChat } from "../../../../context";
import {
  CHAT_INPUT_ADD_MENU_ITEMS,
  DOCUMENT_SEARCH_PROPS,
} from "../../constants";

const EmptyStateView = ({
  attachments,
  onFilesSelected,
  onAttachmentRemove,
  onClearAttachments,
  onAddMenuChange,
  onModeMenuChange,
  onModeTagClose,
  modelAlignMenu,
  documents = [],
  onDocumentSelect,
  onDocumentDelete,
  onDocumentSearchMenuChange,
}) => {
  const {
    sendMessage,
    createNewConversation,
    selectedAgentId,
    selectedConversationId,
    agentIsTyping,
    providers,
    selectedProvider,
    selectedModel,
    onModelChange,
    onProviderChange,
    defaultAgentIdForNewChat,
  } = useHomeChat();

  const effectiveAgentId = selectedAgentId || defaultAgentIdForNewChat;

  const handleSendMessage = useCallback(
    async (messageText) => {
      if (!effectiveAgentId) {
        console.error("No agent selected and no concierge agent available.");
        return;
      }

      const list = attachments || [];
      const fileUuids = list
        .map((a) => a.fileUuid || a.document_uuid)
        .filter((uuid) => uuid);
      const attachmentDetails =
        list.length > 0
          ? list.map((a) => ({
              fileUuid: a.fileUuid || a.document_uuid,
              name: a.name ?? "Document",
              fileType: a.fileType ?? (a.name?.includes?.(".") ? a.name.split(".").pop() : ""),
              isLoading: a.isLoading === true,
            }))
          : undefined;

      let conversationId = selectedConversationId;

      // Crear conversación sin seleccionar aún: así no se dispara fetchMessages que devuelve []
      // y no se muestra AgentView. La selección la hace el wrapper al recibir conversation_uuid del send.
      if (!conversationId && createNewConversation) {
        try {
          const newConversation = await createNewConversation(effectiveAgentId, {
            title: messageText.slice(0, 40),
            selectAfterCreate: false,
          });
          conversationId = newConversation.conversationUuid || newConversation.id;
        } catch (err) {
          console.error("Failed to create conversation:", err);
          return;
        }
      }

      if (conversationId) {
        await sendMessage(messageText, {
          conversationId,
          agentId: effectiveAgentId,
          fileUuids: fileUuids.length > 0 ? fileUuids : undefined,
          attachmentDetails,
        });
        onClearAttachments?.();
      }
    },
    [
      effectiveAgentId,
      selectedConversationId,
      createNewConversation,
      sendMessage,
      attachments,
      onClearAttachments,
    ],
  );

  return (
    <Container>
      <Content>
        <Typography category="title" size="medium" weight="bold">
          How can I help you today?
        </Typography>
        <SecondContainer>
          <ChatInput
            className={"chat-input"}
            placeholder="Ask anything"
            allowUploadFiles
            attachments={attachments}
            onFilesSelected={onFilesSelected}
            onAttachmentRemove={onAttachmentRemove}
            onAddMenuChange={onAddMenuChange}
            onModeMenuChange={onModeMenuChange}
            onModeTagClose={onModeTagClose}
            addMenuItems={CHAT_INPUT_ADD_MENU_ITEMS}
            documentSearchProps={DOCUMENT_SEARCH_PROPS}
            documents={documents}
            onDocumentSelect={onDocumentSelect}
            onDocumentDelete={onDocumentDelete}
            onDocumentSearchDeleteClick={onDocumentDelete}
            onDocumentSearchMenuChange={onDocumentSearchMenuChange}
            isProcessing={agentIsTyping}
            onSend={handleSendMessage}
            {...(providers?.length > 0 && {
              providers,
              selectedProvider,
              selectedModel,
              onModelChange,
              onProviderChange,
              ...(modelAlignMenu && { modelAlignMenu }),
            })}
          />
        </SecondContainer>
      </Content>
    </Container>
  );
};

export default EmptyStateView;
